import React from "react";

export const PageRiskDisclosure = () => {
  return (
    <div className="mx-auto p-[30px] md:px-24 md:py-16 font-sans text-white bg-black md:bg-[#2f3342]">
      <h1 className="text-2xl md:text-3xl font-common-bold text-center mb-8">
        Aspen Digital Financial Limited Risk Disclosure Statement
      </h1>

      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-common-bold mb-4">Introduction</h2>
        <p className="mb-4 text-justify text-sm md:text-base font-common-regular">
          This Risk Disclosure Statement (the {`"Statement"`}) provides Users with information about
          the risks associated with trading in Virtual Assets and the Services provided by Aspen
          Digital Financial Limited (hereinafter referred to as {`"Aspen"`} or {`"ADFL"`}).
        </p>
        <p className="mb-4 text-justify text-sm md:text-base font-common-regular">
          The risks outlined in this statement are not intended to disclose or discuss in detail all
          of the risks associated with trading or holding Virtual Assets or other significant
          aspects of any transaction undertaken through Aspen. This Risk Disclosure Statement is not
          exhaustive and only describes the general nature of the risks involved with trading in
          Virtual Assets. Users should undertake their own assessment regarding the suitability of
          trading in Virtual Assets in the light of their own investigation, objective, research,
          experience, financial resources and their risk appetite. Users are strongly advised to
          read this Risk Disclosure Statement carefully before signing up an account and executing
          transactions on the Aspen platform.
        </p>
      </div>

      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-common-bold mb-4">Disclaimer</h2>
        <p className="mb-4 text-justify text-sm md:text-base font-common-regular">
          We do not guarantee or make any representations, or assume any liability with regard to
          financial results based on the use of the information in this Statement, and further do
          not advise to rely on such information in the process of making a fully informed
          investment decision.
        </p>
        <p className="mb-4 text-justify text-sm md:text-base font-common-regular">
          INVESTMENT IN VIRTUAL ASSETS INVOLVES CERTAIN CONSIDERATIONS AND A HIGH DEGREE OF RISK.
          You should not deal in designated investments unless you understand their nature and the
          extent of your exposure to risk. Not all investments are suitable or appropriate for all
          investors. You should make sure that your chosen investment is appropriate and suitable
          for you (bearing in mind your circumstances, investment objectives and expectations,
          financial position and categorization as a Professional Client). Before committing to any
          specific type of designated investment, you should understand the nature and risks
          associated with that type of investment. In case a designated investment is composed of
          two or more different designated investments or services, the associated risks are likely
          to be greater than the risks associated with any of the components. Whilst we cannot
          disclose all possible risks or significant aspects regarding individual designated
          investments, you should note the following risks.
        </p>
      </div>

      <p className="font-common-bold uppercase my-6 text-sm md:text-base">
        BEFORE MAKING ANY INVESTMENT DECISIONS, USERS SHOULD CAREFULLY CONSIDER WHETHER INVESTMENT
        PRODUCTS/SERVICES ARE SUITABLE IN LIGHT OF THEIR FINANCIAL POSITION, INVESTMENT OBJECTIVES
        AND EXPERIENCE, RISK TOLERANCE AND OTHER RELEVANT CIRCUMSTANCES. MEANWHILE, USERS SHOULD
        ALSO UNDERSTAND THE RISKS ASSOCIATED WITH INVESTMENT PRODUCTS/SERVICES.
      </p>

      <p className="mb-4 text-justify text-sm md:text-base font-common-regular">
        In acceding to or using Aspen Platform and the Site, you represent and warrant to Aspen that
        you have read and understood the disclosures in the Risk Disclosure Statement. You should be
        fully aware of the risks associated with the transactions involving Digital Assets or the
        use of Aspen Platform. You agree and understand that you access and use Aspen Platform at
        your own risk.
      </p>

      <div className="mb-[20px]">
        <h2 className="text-[20px] font-common-bold mb-[15px]">Overview of Risks</h2>
        <p className="mb-[15px] text-justify">
          The Risk Disclosure Statement addresses the following risks associated with trading in
          Virtual Assets in respect of the following matters:
        </p>
        <ul className="ml-[20px] mb-[15px]">
          <li className="mb-[10px]">
            (i) Virtual Assets are not legal tender or backed by a government
          </li>
          <li className="mb-[10px]">(ii) Complexity</li>
          <li className="mb-[10px]">(iii) Market Force</li>
          <li className="mb-[10px]">
            (iv) Loss of value, volatility and uncertainty of future performance
          </li>
          <li className="mb-[10px]">(v) Financial Crime Risk</li>
          <li className="mb-[10px]">(vi) Cyber Risk</li>
          <li className="mb-[10px]">(vii) Technology Risk</li>
          <li className="mb-[10px]">(viii) Regulatory Risk</li>
          <li className="mb-[10px]">(viii) Availability of Virtual Assets</li>
        </ul>
      </div>

      <div className="mb-[20px]">
        <h2 className="text-[20px] font-common-bold mb-[15px]">DISCLOSURES</h2>
        <p className="mb-[15px] text-justify">
          Risks related to the Services, Virtual Assets and Accepted Virtual Assets provided by
          Aspen
        </p>
        <p className="font-common-bold uppercase my-[20px]">
          THE RISK OF LOSS FROM TRANSACTING IN VIRTUAL ASSETS CAN BE SUBSTANTIAL AND YOU SHOULD,
          THEREFORE, CAREFULLY CONSIDER WHETHER TRANSACTING IN VIRTUAL ASSETS IS APPROPRIATE FOR YOU
          IN LIGHT OF YOUR CIRCUMSTANCES AND FINANCIAL RESOURCES. YOU SHOULD BE AWARE OF THE
          FOLLOWING:
        </p>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">
            (i) Virtual Assets are Not Legal Tender or Backed by a Government
          </h3>
          <p className="mb-[15px] text-justify">
            Most Virtual Assets are not legal tender or backed by any government. Counterparties may
            refuse to accept a Virtual Asset as a form of payment on the basis that the Virtual
            Asset. There is no assurance that a person who accepts Virtual Assets as a form of
            payment will continue to do so in the future. A counterparty may be prevented from
            accepting a Virtual Asset as a form of payment due to changes to laws and regulations.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(ii) Complexity</h3>
          <p className="mb-[15px] text-justify">
            The features, functions, characteristics, operation, use and other properties of any
            Virtual Asset and the software, networks, protocols, systems, and other technology
            (including, if applicable, any blockchain) used to administer, create, issue, transfer,
            cancel, use or transact in any Virtual Asset may be complex, technical or difficult to
            understand or evaluate
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(iii) Market Force</h3>
          <p className="mb-[15px] text-justify">
            The value of any Virtual Assets may decrease as well as increase. Trading in Virtual
            Assets may be susceptible to irrational loss of confidence or market forces such as
            speculative bubbles, as a result of any misleading statements or rumors, manipulation,
            trading scams and fraud which could cause a collapse in the demand relative to supply
            without a reason anchored in reality. Any data on the past performance of a Virtual
            Asset does not guarantee future results. Market risks inherent in trading Virtual Assets
            entail exposure to price volatility, fluctuations in Fiat currency exchange rates that
            may, adversely impact the overall market performance. Thus, potentially affecting the
            value of investment or trading position.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">
            (iv) Loss of Value, Volatility and Uncertainty of Future Performance
          </h3>
          <p className="mb-[15px] text-justify">
            There is limited or no fundamental reasoning behind the pricing of Virtual Assets,
            creating the risk of volatility and unpredictability with the price of Virtual Assets
            relative to Fiat Currencies. The price of Virtual Assets can be subject to large
            fluctuations (whether in a Virtual Asset/fiat pairing or Virtual Asset/Virtual Asset
            pairing). The price of a Virtual Asset can be volatile, unpredictable, and inconsistent.
            Virtual Assets have had historically higher price volatility than Fiat Currencies
            without or with limited tangible underlying assets for price reference, allowing
            irrational and exorbitant moves in price, as the process for valuation is speculative
            and uncertain. Sudden shifts in prices are possible at any given moment and could result
            in significant loss.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(v) Financial Crime Risk</h3>
          <p className="mb-[15px] text-justify">
            Virtual Assets provide a higher degree of anonymity for their holders and makes it more
            difficult to trace them compared to conventional assets, which can lead to an increased
            risk of financial crimes due to its decentralized nature and utilization of augmented
            anonymity mechanisms, which can potentially obscure traceability for transactions within
            the ecosystem. Notable financial crimes that may arise include fraud, money laundering,
            the financing of terrorism, dealing with sanctioned persons and breaches of economic
            sanctions.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(vi) Cyber Risk</h3>
          <p className="mb-[15px] text-justify">
            The intangible nature of Virtual Assets and their heavy reliance on technology may make
            them subject to an increased risk of cyber-attack and theft. Virtual Assets are
            susceptible to specific types of cyber-attacks as a result of their network
            architecture. For example, a 51% attack, which is an attack on a blockchain by any
            Person or group of Persons who control more than 50% of the network{`'`}s mining hash
            rate. Attackers with majority control of the network can interrupt the recording of new
            blocks by preventing other miners from completing blocks (block finality), altering
            payment history, and subverting funds. Users should be aware of the potential
            cybersecurity risks associated with virtual assets like malware and ransomware, brute
            force attacks, smurfing/ distributed denial of service (DDOS) attacks, phishing attacks
            which may lead to a significant loss of funds.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(vii) Technology Risk</h3>
          <p className="mb-[15px] text-justify">
            Understanding Virtual Assets requires advanced technical knowledge. Virtual Assets are
            often described in exceedingly technical language that requires a comprehensive
            understanding of applied cryptography and computer science in order to appreciate
            inherent risks. Listing of a Virtual Asset on Aspen does not indicate approval or
            disapproval of the underlying technology regarding that Virtual Asset and should not be
            used as a substitute for each client{`'`}s own understanding of the risks associated
            with that Virtual Asset.
          </p>
          <p className="mb-[15px] text-justify">
            Trading in Virtual Assets on the blockchain relies on the proper functioning of complex
            software which exacerbates the risk of access to or use of Virtual Assets being impaired
            or prevented.Interacting with third-party technologies and software, relatively new
            technologies (such as bridge tools), novel and unproven blockchain infrastructures
            (including blockchain networks and platforms with advanced privacy features utilizing
            pseudonymisation mechanisms and sidechains) in trading Virtual Assets may expose Users
            to vulnerabilities.
          </p>
          <p className="mb-[15px] text-justify">
            The foundation of the software protocols governing Virtual Assets are typically open
            source, indicating that Aspen has no authority over their development and control.
            Furthermore, these software protocols are susceptible to abrupt and substantial
            alterations that can significantly influence the availability, usability, or value of a
            specific Virtual Asset.
          </p>
          <p className="mb-[15px] text-justify">
            Trust and confidence may collapse in a Virtual Asset such as Bitcoin because of, but not
            limited to, unexpected changes imposed by the software developers or others, changes
            introduced by the relevant authority or regulator, the creation of superior competing
            alternative Virtual Assets, or a deflationary or inflationary spiral. Confidence may
            also collapse because of technical problems: if the anonymity of the system is
            compromised, if money is lost or stolen, or if hackers or governments are able to
            prevent any transactions from settling. There may be no mechanism for the recovery of
            lost or stolen Virtual Assets. Any Virtual Asset or technology may change or otherwise
            cease to operate as expected due to a change made to the underlying technology, a change
            made using features or functions built into the underlying technology or a change
            resulting from an attack. Finally, due to their nature, technological difficulties
            experienced by Aspen may prevent access or use of Virtual Assets.
          </p>
          <p className="mb-[15px] text-justify">
            Virtual Asset transactions posted on the blockchain are irreversible. There is no
            guarantee that transactions submitted in error will be recovered. Users should always
            check that the address and network they are sending the assets to is correct.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">(viii) Regulatory Risk</h3>
          <p className="mb-[15px] text-justify">
            Virtual Assets activity conducted outside of the Abu Dhabi Global Market (ADGM) may be
            unregulated or subject to limited regulation. The regulation of Virtual Assets varies
            significantly between jurisdictions, even between the ADGM and other parts of the UAE.
            Any regulatory changes or actions by the Financial Services Regulatory Authority (FSRA)
            or a Non-ADGM regulatory authority may adversely affect the use, transfer, exchange and
            value of a Virtual Asset.
          </p>
          <p className="mb-[15px] text-justify">
            Many jurisdictions are in the process of developing or amending their Virtual Asset
            regulatory regimes. Regulation may develop that restricts the use of Virtual Assets or
            otherwise influences the demand for Virtual Assets, which may affect the price of
            Virtual Assets. Furthermore, banks and other financial institutions may refuse to
            process funds for Virtual Asset transactions, process wire transfers to or from Virtual
            Asset trading platforms, Virtual Asset-related companies or service providers, or
            maintain accounts for persons or entities trading in Virtual Assets. This might result
            in you holding Virtual Assets which you are unable to convert into fiat currency to use.
          </p>
          <p className="mb-[15px] text-justify">
            A User{`'`}s domestic government may make it illegal for the User to trade Virtual
            Assets.
          </p>
        </div>

        <div className="mb-[20px]">
          <h3 className="text-[18px] font-common-bold mb-[15px]">
            (viii) Availability of Virtual Assets
          </h3>
          <p className="mb-[15px] text-justify">
            The ability for Users to purchase Virtual Assets by using the Aspen platform is
            dependent on there being a counterparty willing to sell the same Virtual Asset (and vice
            versa), which is outside of Aspen{`'`}s control. Aspen makes no guarantee as to the
            timing or availability of the ability to purchase or sell Virtual Assets via our
            platform.
          </p>
          <p className="mb-[15px] text-justify">
            Virtual Assets require approval by the FSRA prior to trading it on the Aspen platform.
            Such approval may be withdrawn at any time. Any Virtual Assets may be delisted at any
            time without notice or consent. Accepting the original Virtual Asset does not mean Aspen
            automatically accepts any new Virtual Asset that is forked from the original accepted
            one. Any new Virtual Asset must require approval by the FSRA prior to being traded on
            the Aspen Platform. In case that Aspen does not support the forked Virtual Assets, Users
            will not be able to trade the forked Virtual Asset and need to withdraw it to other
            addresses for further action. During this time the price of the forked Virtual Asset
            might decrease. Accordingly, Aspen is not liable in respect of such protocols and any
            change in the value of any Virtual Asset (whether as a result of a fork or any similar
            change to a Virtual Asset{`'`}s Protocol or otherwise), and Aspen makes no guarantees
            regarding the security, functionality, or availability of such protocols. Users are
            deemed to accept all risks associated with the use of Aspen to conduct Transactions and
            in connection with the Services, including, but not limited to, in connection with the
            failure of hardware, software, and internet connections.
          </p>
          <p className="mb-[15px] text-justify">
            There is no assurance that an Accepted Virtual Asset will continue to be admitted in the
            future.
          </p>
          <p className="mb-[15px] text-justify">
            The value of Virtual Assets may be derived from the continued willingness of Users to
            trade Virtual Assets for Virtual Assets, which may result in the potential for permanent
            and total loss of value of a particular Virtual Asset should the market for it
            disappear. Thinly traded or illiquid markets have an increased potential risk of loss as
            a result of the enhanced volatility and Users may not be able to establish or liquidate
            positions in a Virtual Asset when desired, at favorable prices or at all.
          </p>
        </div>

        <div className="mb-[20px]">
          <h2 className="text-[20px] font-common-bold mb-[15px]">
            Specific Risks Associated with Stablecoins
          </h2>
          <p className="mb-[15px] text-justify">
            Aspen only provides custodian services for Stablecoin operation and is not an issuer,
            operator, manager or beneficiary of any Stablecoin in any manner. Hence, prior to
            initiating any transactions or trades involving Stablecoins, it{`'`}s recommended to
            thoroughly examine the project{`'`}s information page for comprehensive details and to
            understand any specific terms and conditions set by the Stablecoin{`'`}s issuer.
          </p>
          <p className="mb-[15px] text-justify">
            Stablecoins are designed to be pegged to Fiat Currency and be collateralized as 1:1.
            However, Stablecoins are not covered by any deposit insurance protection scheme, and the
            presence of Fiat Currency reserves is not a guarantee for redemption. There is a
            possibility that the assets held in reserves may not be sufficient, or may not be
            available for redemption at times of extremely high demand. Market volatility could
            cause the price of a Stablecoin to fluctuate away from its pegged Fiat Currency.
          </p>
          <p className="mb-[15px] text-justify">
            Stablecoin to Fiat Currency pairs do not come under the direct purview of the FSRA,
            hence these pairs are not overseen by the FSRA for potential market abuse. However,
            these pairs are still obliged to meet fair and orderly trading standards, along with
            undergoing other checks and controls implemented by Aspen.
          </p>
        </div>

        <div className="mb-[20px]">
          <h2 className="text-[20px] font-common-bold mb-[15px]">USDC Specific Risks</h2>
          <p className="mb-[15px] text-justify">
            Introduced in 2018, USD Coin (USDC) is one of the top fiat-backed stablecoins. USDC is a
            centralized token issued by Centre Consortium, which was originally founded by Coinbase
            and Circle Financial.
          </p>
          <p className="mb-[15px] text-justify">
            Each USDC is designed to be backed by USD collateral held in reserve by leading
            regulated US financial institutions. Circle voluntarily publishes financial reports on
            assets held in reserve monthly.
          </p>
          <p className="mb-[15px] text-justify">
            However, USDC is not subject to any deposit insurance protection scheme, and the
            presence of the USD reserve is not a guarantee for redemption. There is a possibility
            that the assets held in reserve are not sufficient or may not be available for
            redemption at times of extremely high demand.
          </p>
          <p className="mb-[15px] text-justify">
            As USDC is a token with a target (price) stability which is said to be secured by assets
            denominated in USD or that are the equivalent of USD, there is a risk that, as a result
            of controlling and regulatory rules imposed for such currency or assets, there may be
            unfavorable changes in use, transfer and redemption of USDC or tax liability may be
            imposed upon USDC holders.
          </p>
          <p className="mb-[15px] text-justify">
            The issuer of USDC relies on its ability to continuously access multiple banking and
            insurance services and platforms. The loss of a critical banking or insurance
            relationship could adversely impact its operating results, and financial conditions,
            potentially marring its ability to continuously offer USDC to users.
          </p>
          <p className="mb-[15px] text-justify">
            Centre Consortium decides on the countries where USDC transactions will be supported or
            materialized and the eligibility and appropriateness of persons who are to perform
            transactions. There is a risk that the UAE may be removed from countries supported
            and/or transactions by certain users with USDC may be blocked. In such case, Aspen may
            stop accepting, remove and/or close USDC for transactions.
          </p>
          <p className="mb-[15px] text-justify">
            For additional assistance or information, please email us to legal@aspendigital.co.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageRiskDisclosure;
